import cleanDeep from "clean-deep";
import AddressLookUp from "@/common/AddressLookUp.js";
import { merge, setWith } from "lodash";
import { useEffect, useRef, useState } from "react";
import { NotificationManager } from "react-notifications";
import { connect } from "react-redux";
import Select from "react-select";
import { industryOptions } from "../../../company-settings/config/IndustryOptions.js";
import CompanyDetailsFields from "@/components/company-settings/general-tab/sections/CompanyDetailsFields.js";

const onboardingOptions = [{ label: "Onboarding by CS", value: "Onboarding by CS" }];

const CompanyDetails = ({
	createCompany,
	companyExists,
	updateCompanyDetails,
	settings,
	profile,
	disabled,
	jurisdictionOptions,
	advisorPage,
	isAdmin,
	prevPage,
	defaultJurisdiction,
	advisorName,
	saving,
}) => {
	const { org } = settings || {};
	const [data, setData] = useState({});
	const updateField = (field, value) => {
		if (!field) return;
		if (field.includes("[")) field = setWith({}, field, value, Object);
		const newData = merge(data, { ...(typeof field == "object" ? field : { [field]: value }) });
		// console.debug(field, value)

		setData({ ...newData });
	};

	const [advisor, setAdvisor] = useState(settings?.advisor || false);
	const [paidByAdvisor, setPaidByAdvisor] = useState(settings?.paidByAdvisor || false);

	const payeReferenceRef = useRef();
	const taxOfficeNoRef = useRef();

	useEffect(() => {
		setData({
			name: settings?.name,
			peNumber: settings?.peNumber,
			industry: settings?.industry,
			jurisdiction: settings?.jurisdiction || defaultJurisdiction,
			phone: settings?.phone,
			aoReference: settings?.aoReference,
			vatNumber: settings?.vatNumber,
			taxNumber: settings?.taxNumber,
			taxOfficeNo: settings?.taxOfficeNo,
			payeRef: settings?.payeRef,
			companyNumber: settings?.companyNumber,
			jobsplusNumber: settings?.jobsplusNumber,
			address: settings?.address,
			billingEmail: settings?.billingEmail,
			principal: settings?.principal,
			principalRole: settings?.principalRole,
			hmrcCredentials: settings?.hmrcCredentials,
			mfaRequirement: settings?.mfaRequirement,
			onboarding: settings?.onboarding,
		});
		setAdvisor(settings.advisor || null);
		setPaidByAdvisor(settings.paidByAdvisor || false);
	}, [JSON.stringify(settings)]);

	const onSubmit = (e) => {
		e.preventDefault();
		e.stopPropagation();

		if (!data.name.replaceAll(" ", "")) {
			NotificationManager.error("Please Enter a Valid Company Name", "Saving Company Details");
			return;
		}
		if (!data.jurisdiction) {
			NotificationManager.error("Please Enter a Valid Jurisdiction", "Saving Company Details");
			return;
		}
		// console.debug(companyExists)
		// return
		if (companyExists)
			updateCompanyDetails(
				cleanDeep(
					{ org, ...data, advisor, paidByAdvisor },
					{ emptyStrings: false, emptyArrays: false, emptyObjects: false },
				),
			);
		else
			createCompany(
				cleanDeep(
					{ ...data, advisor, paidByAdvisor: advisor ? paidByAdvisor : undefined },
					{ emptyStrings: false, emptyArrays: false, emptyObjects: false },
				),
			);
	};

	return (
		<div
			className="tab-pane fade in p-0 active"
			id="btabs-alt-static-justified-general"
		>
			<form
				className="form-grid col-3 p-0"
				onSubmit={onSubmit}
			>
				<div className="form-section col-span-2 row-span-2">
					<div className="form-container col-xs-12">
						<h4>Company Details</h4>
					</div>
					<CompanyDetailsFields
						data={data}
						updateField={updateField}
						jurisdiction={data?.jurisdiction}
						disabled={disabled}
					/>
					<div className="clearfix" />
				</div>
				{profile.isAdvisor && (
					<div className="form-section">
						<div className="col-xs-12 form-container">
							<h4>Advisor</h4>
						</div>
						{isAdmin && (
							<div className="col-xs-12">
								<input
									className="form-control"
									value={advisor ? advisor : ""}
									disabled={true}
								/>
							</div>
						)}
						<div className="col-xs-12 form-container">
							<div>
								<label
									className="css-input switch switch-sm switch-success"
									style={{
										cursor:
											disabled || (isAdmin && advisor && profile.advisorId != advisor)
												? "not-allowed"
												: "auto",
									}}
								>
									<input
										type="checkbox"
										value={profile.advisorId}
										checked={advisor}
										disabled={disabled || (isAdmin && advisor && profile.advisorId != advisor)}
										onChange={(e) => {
											// setValue('advisor',e.target.checked ? profile.advisorId : false, { shouldValidate: true,shouldDirty: true });
											setAdvisor(e.target.checked ? profile.advisorId : false);
										}}
									/>
									<span /> Managed by {profile.advisorId != advisor ? "Advisor" : profile.advisorName}
								</label>
								{advisor && (
									<label
										className="css-input switch switch-sm switch-success"
										style={{
											cursor:
												disabled || (isAdmin && advisor && profile.advisorId != advisor)
													? "not-allowed"
													: "auto",
										}}
									>
										<input
											type="checkbox"
											value={true}
											checked={paidByAdvisor}
											disabled={disabled || (isAdmin && advisor && profile.advisorId != advisor)}
											onChange={(e) => {
												// setValue('advisor',e.target.checked ? profile.advisorId : false, { shouldValidate: true,shouldDirty: true });
												setPaidByAdvisor(!paidByAdvisor);
											}}
										/>
										<span /> Invoice{" "}
										{profile.advisorId != advisor ? "Advisor" : profile.advisorName}
									</label>
								)}
							</div>
						</div>
						<div className="clearfix" />
					</div>
				)}
				<div className="form-section col-span-2 row-span-2">
					<div className="form-container">
						<div className="col-xs-12 pr-0">
							<h4>Company Address</h4>
							<AddressLookUp
								updateInput={(input) => {
									updateField("address", {
										...input,
										number: input?.houseNumber,
										houseNumber: undefined,
										postalCode: input?.postCode,
										postCode: undefined,
									});
								}}
								disabled={disabled}
							/>
						</div>
						{["UK"].includes(data?.jurisdiction) ? (
							<>
								<div className="col-xs-6">
									<div className="form-material form-container">
										<input
											className="form-control form-input"
											id="address[subBuilding]"
											name="address[subBuilding]"
											value={data?.address?.subBuilding}
											onChange={(e) => {
												updateField(e.target.name, e.target.value);
											}}
											autoComplete="off"
											disabled={disabled}
										/>
										<label htmlFor="address[subBuilding]">Sub Building</label>
									</div>
								</div>
							</>
						) : null}

						<div className="col-xs-6">
							<div className="form-material form-container">
								<input
									className="form-control form-input"
									id="address[number]"
									name="address[number]"
									value={data?.address?.number}
									onChange={(e) => {
										updateField(e.target.name, e.target.value);
									}}
									autoComplete="off"
									disabled={disabled}
								/>
								<label htmlFor="address[number]">Building</label>
							</div>
						</div>

						<div className={`col-xs-${["UK"].includes(data?.jurisdiction) ? "12" : "6"}`}>
							<div className="form-material form-container">
								<input
									className="form-control form-input"
									id="address[street]"
									name="address[street]"
									value={data?.address?.street}
									onChange={(e) => {
										updateField(e.target.name, e.target.value);
									}}
									autoComplete="off"
									disabled={disabled}
								/>
								<label htmlFor="address[street]">Street</label>
							</div>
						</div>

						<div className="col-xs-6">
							<div className="form-material form-container">
								<input
									className="form-control form-input"
									id="address[city]"
									name="address[city]"
									value={data?.address?.city}
									onChange={(e) => {
										updateField(e.target.name, e.target.value);
									}}
									autoComplete="off"
									disabled={disabled}
								/>
								<label htmlFor="address[city]">City</label>
							</div>
						</div>

						{["UK"].includes(data?.jurisdiction) ? (
							<>
								<div className="col-xs-6">
									<div className="form-material form-container">
										<input
											className="form-control form-input"
											id="address[locality]"
											name="address[locality]"
											value={data?.address?.locality}
											onChange={(e) => {
												updateField(e.target.name, e.target.value);
											}}
											autoComplete="off"
											disabled={disabled}
										/>
										<label htmlFor="address[locality]">Locality</label>
									</div>
								</div>
								<div className="col-xs-4">
									<div className="form-material form-container">
										<input
											className="form-control form-input"
											id="address[county]"
											name="address[county]"
											value={data?.address?.county}
											onChange={(e) => {
												updateField(e.target.name, e.target.value);
											}}
											autoComplete="off"
											disabled={disabled}
										/>
										<label htmlFor="address[county]">County</label>
									</div>
								</div>
								<div className="col-xs-4">
									<div className="form-material form-container">
										<input
											className="form-control form-input"
											id="address[country]"
											name="address[country]"
											value={data?.address?.country}
											onChange={(e) => {
												updateField(e.target.name, e.target.value);
											}}
											autoComplete="off"
											disabled={disabled}
										/>
										<label htmlFor="address[country]">Country</label>
									</div>
								</div>
							</>
						) : null}

						<div className={`col-xs-${["UK"].includes(data?.jurisdiction) ? 4 : 6}`}>
							<div className="form-material form-container">
								<input
									className="form-control form-input"
									id="address[postalCode]"
									name="address[postalCode]"
									value={data?.address?.postalCode}
									autoComplete="off"
									onChange={(e) => {
										updateField(e.target.name, e.target.value);
									}}
									disabled={disabled}
								/>
								<label htmlFor="address[postalCode]">Postcode</label>
							</div>
						</div>
					</div>
					<div className="clearfix" />
				</div>
				<div className="form-section row-span-1">
					<div className="col-xs-12">
						<h4>Payroll Jurisdiction</h4>
					</div>
					<div className="col-xs-12 form-container">
						<div className="form-material">
							<Select
								options={jurisdictionOptions}
								value={jurisdictionOptions.find((i) => i.value == data?.jurisdiction)}
								name="jurisdiction"
								onChange={(e) => {
									updateField("jurisdiction", e?.value || null);
								}}
							/>
						</div>
					</div>
					<div className="clearfix" />
				</div>

				<div className="col-span-3">
					{advisorPage ? (
						<button
							type="button"
							className="btn btn-default"
							onClick={prevPage}
						>
							Back
						</button>
					) : null}
					<button
						className="btn btn-success right"
						type="submit"
						disabled={saving}
					>
						{saving ? "Saving" : "Save"}
					</button>
				</div>
			</form>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		profile: state?.my?.profile,
		companyExists: !!state.company.newCompany.org,
		isAdmin: state.my?.profile?.isAdmin,
		settings: state.company.newCompany,
		defaultJurisdiction: state.advisors?.settings?.jurisdiction,
		jurisdictionOptions: (state.jurisdictions || [])?.map(({ countryCode, name }) => ({
			label: `${name}/${countryCode}`,
			value: countryCode,
		})),
		advisorName: state.my?.profile?.advisorName,
		saving: state.company?.saving,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyDetails);
